import PropTypes from "prop-types";

import { ModalButton } from "../../ModalButton";

const MilitaryAffiliation = (props) => {
	const { setMediaAlphaState, isLastStep } = props;

	const updateState = (val) => {
		const value = val === "true" ? 1 : 0;
		setMediaAlphaState({ military_affiliation: value }, isLastStep);
	};

	return (
		<div className="tw-mb-8 tw-mt-4">
			<div className="tw-mb-8 tw-text-center tw-font-semibold tw-leading-5 tw-text-black">
				Are you affiliated with the military?
			</div>
			<div className="tw-flex tw-justify-evenly">
				<ModalButton onPress={() => updateState("true")}>Yes</ModalButton>
				<ModalButton onPress={() => updateState("false")}>No</ModalButton>
			</div>
		</div>
	);
};

MilitaryAffiliation.propTypes = {
	setMediaAlphaState: PropTypes.func.isRequired,
	isLastStep: PropTypes.bool.isRequired,
};

export default MilitaryAffiliation;
